import { isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { SaveAiDialogData, SaveAiDialogDataResult } from '../../api/commands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SaveAiDialog extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveAiDialog';

    public _commandResult: SaveAiDialogDataResult = null;
    public constructor(
        public targetUsers: string,
        public typeOfProduct: string,
        public purpose: string,
        public keyFeatures: string,
        public platformCompatibility: string,
        public pricingModel: string,
        public additionalNotes: string,
        public language: string
    ) {
        super(SaveAiDialog.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveAiDialog): Promise<boolean> => {
    return useSendCommand(action, {
        isCurrent: () => isActionCurrent(action),
        createCommand: () =>
            new SaveAiDialogData(
                state.id,

                action.targetUsers,
                action.typeOfProduct,
                action.purpose,
                action.keyFeatures,
                action.platformCompatibility,
                action.pricingModel,
                action.additionalNotes,
                action.language
            ),
        onError: () => {
            return false;
        },
        onSuccess: (res) => {
            if (isActionCurrent(action)) action._commandResult = res;
        },
    });
};

const reducer = (state: StorymapState, action: SaveAiDialog): void => {
    if (action._commandResult && action._commandResult.StatusCode != 200) {
        return;
    }

    state.aiData.targetUsers = action.targetUsers;
    state.aiData.typeOfProduct = action.typeOfProduct;
    state.aiData.purpose = action.purpose;
    state.aiData.keyFeatures = action.keyFeatures;
    state.aiData.platformCompatibility = action.platformCompatibility;
    state.aiData.pricingModel = action.pricingModel;
    state.aiData.additionalNotes = action.additionalNotes;
    state.aiData.language = action.language;
};

//@ts-ignore
registerMiddleware(SaveAiDialog.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveAiDialog.ACTION_TYPE, reducer);
